<div #target class="parent-assigned-state">
  <kendo-treelist #treelist [kendoTreeListFlatBinding]="displayObjects" [style.height.%]="100" [loading]="loading"
    [resizable]="true" [sortable]="true" kendoTreeListExpandable idField="id" parentIdField="objectId"
    [selectable]="settings" [(selectedItems)]="selected" kendoTreeListSelectable
    (selectionChange)="selectionChange($event)" [rowClass]="rowCallback" [(expandedKeys)]="expandedIds"
    [initiallyExpanded]="false"  
    
    [expandBy]="'id'"
    [(expandedKeys)]="expandedIds"

    (excelExport)="onExcelExport($event)">
    <ng-template kendoTreeListToolbarTemplate>
      <form autocomplete="off">
        <kendo-textbox [style.width.px]="width"  placeholder="Search in Order,Name or Email"
        autocomplete="search-main" (valueChange)="onFilter($event)" name="popupSearch"></kendo-textbox>
      </form>
      
      <kendo-treelist-spacer></kendo-treelist-spacer>
      <button kendoButton class="allbuttons" [disabled]="!displayObjects.length" [svgIcon]="iconNames[0]"
        (click)="expandAll()">
        Expand All
      </button>
      <button kendoButton class="allbuttons" [disabled]="!displayObjects.length" [svgIcon]="iconNames[1]"
        (click)="collapseAll()">
        Collapse All
      </button>
      <button kendoTreeListExcelCommand class="allbuttons" [svgIcon]="excelSVG">
        Export
      </button>
      <button class="allbuttons" kendoButton (click)="onUploadClick()">
        <div style="display: flex;">
          <kendo-svg-icon [icon]="iconNames[2]" style="margin-right: 2px;margin-top: 2px"
            size="medium"></kendo-svg-icon>
          <div>Upload</div>
        </div>
      </button>
    </ng-template>

    <kendo-treelist-column [expandable]="true" field="name" title="Name" [width]="80">
      <ng-template kendoTreeListCellTemplate let-dataItem>
        <span [ngClass]="{'formatting':  dataItem.objectId==null}">{{
          dataItem.name
          }}</span>
      </ng-template>
    </kendo-treelist-column>
    <kendo-treelist-column field="description" title="Email" [width]="60">

    </kendo-treelist-column>
    <kendo-treelist-column field="accessName" title="Access" [width]="60">
    </kendo-treelist-column>
    <kendo-treelist-column field="accessId" title="AccessID" [width]="60" [hidden]="true">
    </kendo-treelist-column>
    <kendo-treelist-excel [fileName]="getFileName()"></kendo-treelist-excel>
  </kendo-treelist>
  

</div>

<div>
    <kendo-window title="Users" *ngIf="openeduserswindow" (close)="closeUsersWindow()" [width]="800" [height]="380"
      [resizable]="false" [top]="50">
      <div style="display: flex;">
        <input type="text" style="display:none" autocomplete="new-password">
        <form autocomplete="on">
          <kendo-textbox [style.width.px]="usersWidth" 
          style="margin-right: 5px;margin-top: 20px;" [style.height.px]="29" autocomplete="new-password"
          placeholder="Search in Name or Email" autocomplete="username" name="mainSearch"
          (keydown)="onFilterUsers($event)"></kendo-textbox>
        </form>
       
        <div>
          <kendo-label class="label" #accesstype id="accesstype" text="Access Type"></kendo-label>
          <kendo-dropdownlist #usertypes [data]="uiAccessItems" textField="text" valueField="value"
            [value]="accessSelectedItem" (valueChange)="accessAddTypeChange($event)" [style.width.px]="180">
          </kendo-dropdownlist>
        </div>
      </div>
      <div style="height:68%;">
        <kendo-grid class="k-grid k-grid-header custom2" [kendoGridBinding]="displayUsers" kendoGridSelectBy="email"
          [(selectedKeys)]="selection" [selectable]="{ mode: 'single'}" [loading]="usersLoading" [sortable]="true"
          [size]="smallSize" [resizable]="true" (cellClick)="onUserCellClick($event)" scrollable="virtual"
          [pageSize]="pageSize" [style.height.%]="100" [rowHeight]="15" [filterable]="false" [rowClass]="rowCallbackAddUser" >
          <kendo-grid-column field="id" title="ID" [width]="40"></kendo-grid-column>
          <kendo-grid-column field="email" title="Email" [width]="200"></kendo-grid-column>
          <kendo-grid-column field="firstname" title="First Name" [width]="100"></kendo-grid-column>
          <kendo-grid-column field="lastname" title="Last Name" [width]="100"></kendo-grid-column>
          <kendo-grid-column field="companyName" title="Company Name" [width]="120"></kendo-grid-column>
        </kendo-grid>

      </div>

      <div class="k-actions k-actions-end">
        <button kendoButton type="button" class="allbuttons" (click)="closeUsersWindow()">Cancel</button>

        <button kendoButton type="button" (click)="addUser()" class="allbuttons" [disabled]="addbutton">Add</button>
      </div>
      <div class="k-dialog-content">
        <ng-container kendoDialogContainer></ng-container>
      </div>
    </kendo-window>
    <div>
      <kendo-window title="Access Right" *ngIf="openedaccesswindow" (close)="closeAccessWindow()" [width]="300"
        [height]="200" [resizable]="false" [top]="50" [left]="60">
        <kendo-label class="label" #accesstype id="accesstype" text="Access Type for:"></kendo-label>
        <kendo-label class="label" #accesstype id="accesstype" text={{selectedAccessObject.email}}></kendo-label>
        <kendo-dropdownlist #usertypes [data]="uiAccessItems" textField="text" valueField="value"
          [value]="accessSelectedItem" (valueChange)="accessTypeChange($event)" [style.width.px]="260">
        </kendo-dropdownlist>
        <div class="k-actions k-actions-end">
          <button kendoButton type="button" class="allbuttons" (click)="closeAccessWindow()">Cancel</button>

          <button kendoButton type="button" class="allbuttons" (click)="saveAccess()"
            [ngClass]="{'disable': accesssavebutton}">Save</button>
        </div>
        <div class="k-dialog-content">
          <ng-container kendoDialogContainer></ng-container>
        </div>
      </kendo-window>
    </div>
  </div>


<kendo-contextmenu (select)="contextSelect($event, this)" *ngIf="show" [target]="target"
  [items]="contextmenu"></kendo-contextmenu>

<kendo-window *ngIf="showConflictPopup" title="Users Already Exist" [width]="600" [top]="100" [resizable]="true"
  (close)="showConflictPopup = false">
  <div style="max-height: 500px; overflow-y: auto;">


    <p>User already exists to following orders. Do you want to override? or continue and add user for remaining orders?
    </p>

    <kendo-grid [data]="conflictingUsers" [scrollable]="'scrollable'"
      [height]="conflictingUsers.length > 6 ? 240 : conflictingUsers.length * 60">
      <kendo-grid-column field="name" title="Order"></kendo-grid-column>
      <kendo-grid-column field="accessName" title="Access"></kendo-grid-column>
    </kendo-grid>
  </div>

  <div class="k-actions k-actions-end">
    <button kendoButton (click)="onCancelConflict()" [primary]="true">Cancel</button>
    <button kendoButton (click)="onOverride()" [primary]="true">Override</button>
    <button kendoButton (click)="onContinueConflict()" [primary]="true">Continue</button>
  </div>
</kendo-window>

<kendo-dialog *ngIf="showConfirmDialog" title="Confirm Navigation" (close)="onCancelRemove()" [width]="'580px'"  
  [height]="'190px'">
  <p>Are you sure you want to remove user from all orders? This action cannot be undone.</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="onCancelRemove()">Cancel</button>
    <button kendoButton class="allbuttons" (click)="onConfirmRemove()" themeColor="primary">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>

<div>
  <kendo-window title={{windowTitle}} *ngIf="openedUploadWindow" (close)="closeUploadWindow()" [width]="550"
    [height]="400" [resizable]="false" [top]="20" [left]="30">
    <br>
    <div id="spreadsheet">
      <kendo-spreadsheet [sheets]="exceldata" #spreadsheet style="height: 260px; width: 100%" [rowHeight]="20"
        [headerHeight]="10" [columns]="3" [menuItems]="items" (excelExport)="onExcelExportInUpload($event)">
      </kendo-spreadsheet>
    </div>
    <div class="k-actions k-actions-end">
      <button kendoButton class="blue" class="allbuttons" type="button" (click)="closeUploadWindow()">Cancel</button>

      <button kendoButton class="blue" class="allbuttons" type="button"
        (click)="saveExcelSample(spreadsheet)">Validate</button>
    </div>
    <div class="k-dialog-content">
      <ng-container kendoDialogContainer></ng-container>
    </div>
  </kendo-window>

</div>

<ng-template #dialogContent>
  <div style="max-height: 80px; overflow-y: auto;">
    
    <div *ngIf="uploadObjects.length > 0">
      {{ uploadObjects.length }} Access(es) will be uploaded.
    </div>

    <div *ngIf="removals.length > 0">
      {{ removals.length }} user(s) will be removed from respective orders.
    </div>

    <br *ngIf="uploadObjects.length > 0 || removals.length > 0">
    <br *ngIf="uploadObjects.length > 0 || removals.length > 0">

  </div>
</ng-template>

<kendo-window [title]="title" *ngIf="errorWindow" [width]="500" [height]="250" [top]="20" [draggable]="true"
  [resizable]="true" (close)="errorWindow = false">
  <div class="error-dialog-content" style="height: 100%; overflow: auto;">
    <div class="error-text-container" style="height: calc(100% - 50px); overflow: auto;">
      <pre class="error-text-block" style="white-space: pre-wrap; word-wrap: break-word;">{{ content }}</pre>
    </div>
    <kendo-dialog-actions>
      <button kendoButton style="height: 30px;background-color: #1825aa;color: white"
        (click)="copyToClipboard();success('Ready to paste in Excel')">Copy for Excel</button>
      <button kendoButton style="height: 30px;background-color: #1825aa;color: white"
        (click)="errorWindow = false">Cancel</button>
    </kendo-dialog-actions>
  </div>
</kendo-window>


<ng-template #userExistsDialog>
  <div style="padding: 10px;">
    <p>User already exists for the following orders. Do you want to override and add/Remove the remaining users if any or
      cancel?</p>
    <kendo-grid [data]="warningGridData" [height]="150">
      <kendo-grid-column field="order" title="Order" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="email" title="Email" [width]="200"></kendo-grid-column>
      <kendo-grid-column field="access" title="Access" [width]="150"></kendo-grid-column>
    </kendo-grid>
  </div>
</ng-template>

<ng-template #companyDifferentDialougue>
  <div style="padding: 10px;">
    <p> Warning: User Company is not associated with Order for below records.Do you wish to continue adding User to Order?
</p>
    <kendo-grid [data]="diffCompanyWarningGridData" [height]="150">
      <kendo-grid-column field="order" title="Order" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="email" title="Email" [width]="200"></kendo-grid-column>
      <kendo-grid-column field="access" title="Access" [width]="150"></kendo-grid-column>
    </kendo-grid>
  </div>
</ng-template>

<kendo-window
  [title]="title || 'Copy Access'"
  *ngIf="showCopyAccessDialog"
  [width]="500"
  [height]="300"
  [top]="20"
  [draggable]="true"
  [resizable]="true"
  (close)="showCopyAccessDialog = false">
  <div class="copy-access-content" style="height: 100%; display: flex; flex-direction: column;">
    <!-- Scrollable body (matches your pattern) -->
    <div class="copy-access-body" style="height: calc(100% - 50px); overflow: auto; padding-right: 4px;">
      <!-- Clear label -->
      <div class="hint" style="margin-bottom: 8px;">
        You are about to copy access of
        <strong>{{ selectedAccessObject.name }}</strong>
        to below selected user.
      </div>
      <br>

      <!-- Target user selector -->
      <label class="k-label" for="targetUser" style="display:block; margin-bottom: 6px;">
        Select the target user
      </label>

      <kendo-combobox
        id="targetUser"
        [data]="displayUsers"
        textField="name"
        valueField="id"
        [filterable]="true"
        [placeholder]="'Search user by name or email...'"
        [valuePrimitive]="true"
        [loading]="searching"
        [(ngModel)]="selectedTargetUserId"
        (filterChange)="onFilterChange($event)"
        style="width: 100%;">
        
        <ng-template kendoComboBoxItemTemplate let-item>
          <div class="user-option">
            <div class="name" style="font-weight:600;">{{ item.name }}</div>
            <div class="email" *ngIf="item.email" style="font-size:12px;color:#666;">
              {{ item.email }}
            </div>
          </div>
        </ng-template>
        <ng-template kendoComboBoxNoDataTemplate>
          <div class="no-data">No users found</div>
        </ng-template>
      </kendo-combobox>

      <!-- Validation -->
      <div
        class="validation"
        *ngIf="selectedTargetUserId === sourceUserId"
        style="margin-top:8px;color:#a01;"
      >
        Target user cannot be the same as the source user.
      </div>

      <!-- Error -->
      <div
        class="error"
        *ngIf="errorMsg"
        style="margin-top:10px;color:#b00020;font-weight:600;"
      >
        {{ errorMsg }}
      </div>
    </div>

    <!-- Footer (buttons styled like your sample) -->
    <div style="display:flex; gap:8px; justify-content:flex-end; padding-top:8px;">
      <button
        kendoButton
        style="height: 30px; background-color: #1825aa; color: white"
        (click)="onCancel()"
        [disabled]="loading"
      >
        Cancel
      </button>

      <button
        kendoButton
        style="height: 30px; background-color: #1825aa; color: white"
        [disabled]="loading || selectedTargetUserId === sourceUserId"
        (click)="onCopy()">
        <span *ngIf="!loading">Copy Access</span>
        <span *ngIf="loading">Copying...</span>
      </button>
    </div>
  </div>
</kendo-window>

<kendo-window *ngIf="showCopyConflictPopup" title="Users Already Exist" [width]="600" [top]="100" [resizable]="true"
  (close)="showConflictPopup = false">
  <div style="max-height: 500px; overflow-y: auto;">


    <p>The selected user already has some of these permissions. Do you want to override the existing access or continue and add only the missing permissions?
    </p>

    <kendo-grid [data]="copyConflictingUsers" [scrollable]="'scrollable'"
      [height]="conflictingUsers.length > 6 ? 240 : copyConflictingUsers.length * 60">
      <kendo-grid-column field="name" title="Order"></kendo-grid-column>
      <kendo-grid-column field="accessName" title="Access"></kendo-grid-column>
    </kendo-grid>
  </div>

  <div class="k-actions k-actions-end">
    <button kendoButton (click)="onCancelCopy()" [primary]="true">Cancel</button>
    <button kendoButton (click)="onOverrideCopy()" [primary]="true">Override</button>
    <button kendoButton (click)="onContinueCopyConflict()" [primary]="true">Continue</button>
  </div>
</kendo-window>